import React, { useState, useEffect } from 'react'
import Layout from '../layout/Layout'
import Spinner from '../layout/Spinner'
import DatePicker from 'react-datepicker'
import formatDate from '../utils/FormatDate'
import axios from 'axios'
import { api } from '../utils/Api'
import { toCurrency, toThousands } from '../utils/Convert'
import SellerPicker from './SellerPicker'
import { CSVLink } from 'react-csv'

const SalesBySeller = () => {
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [loading, setLoading] = useState(false)
    const [salesBySeller, setSalesBySeller] = useState([])
    const [seller, setSeller] = useState('all')
    const [sellerName, setSellerName] = useState('All')
    const [message, setMessage] = useState('')

    useEffect(() => {
        if(seller !== '') getJobs(seller, sellerName)
    }, [startDate, endDate])

    useEffect(() => {
        getJobs('all', 'All')
    }, [])


    const getJobs = async (currentSeller, currentSellerName) => {
        const url = api + `/salesbysellerreport/${currentSeller}?startDate=${formatDate(startDate)}&endDate=${formatDate(endDate)}`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            setLoading(true)
            setMessage('')
            setSalesBySeller([])
            const { data } = await axios.get(url)

            if (data.length !== 0) {
                const finalList = data.map(item => ({
                    seller: item.seller,
                    customer: item.customer,
                    foreman: item.foreman,
                    locality: item.locality,
                    yards: item.yards,
                    amount: item.amount,
                    jobs: item.jobs,
                    missionJobs: item.missionJobs,
                    sanBenitoJobs: item.sanBenitoJobs,
                    brownsvilleJobs: item.brownsvilleJobs,
                    missionYards: item.missionYards,
                    sanBenitoYards: item.sanBenitoYards,
                    brownsvilleYards: item.brownsvilleYards,
                }))
                setSalesBySeller(finalList)
            } else {
                setMessage('Seller do not contain jobs')
            }
            setLoading(false)
        } catch (err) {
            console.error(err)
            setMessage('Error loading data')
            setLoading(false)
        }
    }

    const csvHeaders = [
        { label: 'Seller',            key: 'seller' },
        { label: 'Customer',          key: 'customer' },
        { label: 'Foreman',           key: 'foreman' },
        { label: 'Locality',          key: 'locality' },
        { label: 'Mission Jobs',      key: 'missionJobs' },
        { label: 'San Benito Jobs',   key: 'sanBenitoJobs' },
        { label: 'Brownsville Jobs',  key: 'brownsvilleJobs' },
        { label: '# Jobs',            key: 'jobs' },
        { label: 'Mission CY',        key: 'missionYards' },
        { label: 'San Benito CY',     key: 'sanBenitoYards' },
        { label: 'Brownsville CY',    key: 'brownsvilleYards' },
        { label: 'YD3',               key: 'yards' },
        { label: 'Amount',            key: 'amount' },
    ]

    const RenderLoading = () => {
        return <Spinner />
    }

    const RenderSales = () => {
        if(salesBySeller.length > 0){
                return <div style={{paddingTop: 20}} >
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Seller</th>
                                <th>Customer</th>
                                <th>Foreman</th>
                                <th>Locality</th>
                                <th style={{textAlign:'right'}}>Mission Jobs</th>
                                <th style={{textAlign:'right'}}>San Benito Jobs</th>
                                <th style={{textAlign:'right'}}>Brownsville Jobs</th>
                                <th style={{textAlign:'right'}}># Jobs</th>
                                <th style={{textAlign:'right'}}>Mission CY</th>
                                <th style={{textAlign:'right'}}>San Benito CY</th>
                                <th style={{textAlign:'right'}}>Brownsville CY</th>
                                <th style={{textAlign:'right'}}>YD3</th>
                                <th style={{textAlign:'right'}}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                salesBySeller.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{item.seller}</td>
                                        <td>{item.customer}</td>
                                        <td>{item.foreman}</td>
                                        <td>{item.locality}</td>
                                        <td style={{textAlign:'right'}}>{item.missionJobs}</td>
                                        <td style={{textAlign:'right'}}>{item.sanBenitoJobs}</td>
                                        <td style={{textAlign:'right'}}>{item.brownsvilleJobs}</td>
                                        <td style={{textAlign:'right'}}>{item.jobs}</td>
                                        <td style={{textAlign:'right'}}>{toThousands(item.missionYards)}</td>
                                        <td style={{textAlign:'right'}}>{toThousands(item.sanBenitoYards)}</td>
                                        <td style={{textAlign:'right'}}>{toThousands(item.brownsvilleYards)}</td>
                                        <td style={{textAlign:'right'}}>{toThousands(item.yards)}</td>
                                        <td style={{textAlign:'right'}}>{toCurrency(item.amount,2)}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>

                </div>
        }else{
            return <div style={{paddingTop: 20, width: '100%', textAlign:'center'}}>{message}</div>
        }
    }

    const onChangeSeller = selectedOption => {
        if (selectedOption) {
            setSeller(selectedOption.value)
            setSellerName(selectedOption.label)
            getJobs(selectedOption.value, selectedOption.label)
        }
    }

    return (
        <Layout
        title='Sales By Seller'
        description='Sales By Seller And Clients'
        >
            <div className='form-group row' style={{maxWidth: '100%'}}>
                <div className='col-sm-2'>
                    <label className='text-muted'>Start Date</label>
                    <DatePicker
                        selected={startDate}
                        minDate={new Date('01/01/2022')}
                        maxDate={new Date()}
                        onChange={(date) => setStartDate(date)}
                    />
                </div>
                <div className='col-sm-2'>
                    <label className='text-muted'>End Date</label>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        minDate={startDate}
                        maxDate={new Date()}
                    />
                </div>
                <div className='col-sm-3'>
                    <label className='text-muted'>Seller</label>
                    <SellerPicker action={onChangeSeller} includeAll />
                </div>
                <div className='col-sm-2' style={{display:'flex', alignItems:'flex-end'}}>
                    <CSVLink
                        data={salesBySeller}
                        headers={csvHeaders}
                        filename={`sales-by-seller-${sellerName || 'report'}.csv`}
                        className='btn btn-outline-secondary btn-sm'
                        style={{whiteSpace:'nowrap'}}
                    >
                        Download Report
                    </CSVLink>
                </div>
            </div>
            {
                loading ? <RenderLoading/> : <RenderSales/>
            }
        </Layout>
    )
}

export default SalesBySeller
